module.exports = __webpack_public_path__ + "img/image2.53527b33.png";